import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserTravelVisaForm } from "Bands/components";
import { editUserTravelVisa, userTravelVisaSelectorCreator } from "Bands/state";
import { IUserTravelVisaPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Passport } from "shared/assets/icons";

const { userTravelVisa: visCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserTravelVisaModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const visaIdSelector = useMemo(() => userTravelVisaSelectorCreator(id), [id]);
  const visa = useSelector(visaIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserTravelVisaPatchData) => {
    dispatch(editUserTravelVisa({ id, data }));
  };

  const defaultValues = useMemo(() => {
    const files: { [key: string]: { id: string; originalURL: string } } = {};

    visa?.files.forEach(({ id, source }, index) => {
      if (!source) return;

      files[`files.${index}`] = { id, originalURL: source };
    });

    // show original uploaded files as preview
    return {
      ...visa,
      files,
    };
  }, [visa]);

  return (
    <UserEntityModal
      defaultValues={defaultValues}
      title={visCopy.edit.title}
      icon={Passport}
      action={USER_ACTIONS.editUserTravelVisa}
      buttons={buttons}
      successMessage={visCopy.messages.edited}
      Component={UserTravelVisaForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
